// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-overlay-preloader{align-items:center;background:hsla(0,0%,100%,.6);bottom:0;display:flex;justify-content:center;left:0;position:absolute;right:0;top:0;z-index:800}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
